<template>
    <div class="container-puf">
        <div class="name">黑加油站线索</div>
        <div class="list">
            <div class="item" v-for="(item,index) in dataList" :key="index">
                <div class="title"><span class="type" :class="'type'+item.typeName">{{item.typeName}}</span> {{item.title}}</div>
                <div class="time">{{item.timePoint}}</div>
                <!--                    <div class="content">通知：11111111111</div>-->
                <div class="lookInfo" @click="goDetail(item.id)">
                    <div>详情</div>
                    <div class="el-icon-arrow-right"></div>
                </div>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="form.page"
                    :page-size="form.pageSize"
                    layout="total, prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {noticePage} from "../../../api";

    export default {
        name: "fire",
        data(){
            return {
                form: {
                    page:1,
                    pageSize:10
                },
                dataList:[],
                total:0,
            }
        },
        mounted(){
            this.getData()
        },
        methods:{
            getData(){
                noticePage(this.form).then(res=>{
                    // console.log(res)
                    this.dataList = res.data.list
                    this.total = res.data.totalCount
                })
            },
            goDetail(id){
                this.$router.push({name:'noticeDetail',query:{id:id}})
            },
            handleSizeChange(val) {
                this.form.pageSize = val
                this.getData()
            },
            handleCurrentChange(val) {
                this.form.page = val
                this.getData()
            }
        }
    }
</script>

<style scoped lang="less">
    .container-puf{
        padding-top: 20px;
    }
    .name{
        font-size: 24px;
        padding-bottom: 20px;
        font-weight: bold;
        color: #ff6d10;
    }
    .list{
        height: calc(100vh - 200px);
        overflow: auto;
        padding: 0 4px;
        .item{
            background: #fff;
            padding: 10px;
            border-radius: 10px;
            margin-bottom: 10px;
            box-shadow: 0 2px 6px 0 rgba(0, 0 ,0,0.26);
            .title{
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 8px;
                display: flex;
                align-items: center;
                .type{
                    margin-right: 20px;
                    display: inline-block;
                    width: 50px;
                    padding: 4px 0;
                    text-align: center;
                    font-size: 12px;
                    font-weight: normal;
                    background: #d74a44;
                    border-radius: 3px;
                    color: white;
                }

                .type公告{
                    background: #3388ff;
                }
            }
            .time{
                font-size: 12px;
                color: #bbb;
                margin-bottom: 8px;
            }
            .content{
                font-size: 14px;
                color: #aaa;
                margin-bottom: 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                padding-right: 50px;
            }
            .lookInfo{
                border-top: 1px solid #ddd;
                padding-top: 8px;
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
    .pagination{
        background: white;
        margin-top: 10px;
    }
</style>
